import { useCallback, useState } from 'react';

export enum TaskTab {
  Execute,
  When,
  Payment,
  Confirm,
}

interface UseTaskTabsResult {
  currentTab: TaskTab;
  changeTab: (tab: TaskTab) => void;
  passedTabs: Set<TaskTab>;
}

const INITIAL_TAB = TaskTab.Execute;

const ORDERED_TABS = [
  TaskTab.Execute,
  TaskTab.When,
  TaskTab.Payment,
  TaskTab.Confirm,
];

export function useTaskTabs(): UseTaskTabsResult {
  const [currentTab, setCurrentTab] = useState<TaskTab>(INITIAL_TAB);
  const [passedTabs, setPassedTabs] = useState<Set<TaskTab>>(() => new Set());

  const changeTab = useCallback(
    (tab: TaskTab) => {
      if (currentTab === tab) {
        return;
      }

      const newPassedTabs = new Set<TaskTab>();
      let isPassed = false;

      ORDERED_TABS.forEach(orderedTab => {
        if (isPassed) {
          return;
        }

        newPassedTabs.add(orderedTab);
        if (orderedTab === tab) {
          isPassed = true;
        }
      });

      setPassedTabs(newPassedTabs);
      setCurrentTab(tab);
    },
    [currentTab],
  );

  return {
    currentTab,
    changeTab,
    passedTabs,
  };
}
